<style scoped>
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
</style>

<template>
  <div>
    <v-layout class="d-flex justify-space-between">
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >รายชื่อลูกค้าใหม่</div>
      <v-spacer></v-spacer>
    </v-layout>
    <v-divider class="my-2"></v-divider>
    <filterCustomer :isfromNew="isfromNew" v-on:returnDessert="clickReturn" :fromPage="'confirm_customer'" > </filterCustomer>
    <!-- <v-layout class="mb-n3">
      <v-btn color="white excel-border" elevation="0" light>
        <v-icon left>mdi-printer</v-icon>ดาวน์โหลด excel
      </v-btn>
    </v-layout>
    <v-row>
      <v-col></v-col>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>-->
    <v-data-table :headers="headers" :items="getIndex" :search="search">
      <template v-slot:[`item.print`]="{ item }">
        <v-btn color="success" small class="mb-0" @click="print_contract(item)">
          <v-icon>mdi-printer</v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.edit`]="{ item }">
        <v-btn color="info" small class="mb-0 font-weight-bold" @click="view_document(item)">
          <v-icon left>mdi-file-document-outline</v-icon>แสดง
        </v-btn>
      </template>
      <template v-slot:[`item.delete`]="{ item }">
        <v-btn color="warning" small class="mb-0" @click="delete_contract(item)">
          <v-icon left>mdi-trash-can-outline</v-icon>ลบ
        </v-btn>
      </template>
      <!-- <template v-slot:[`item.confirm`]="{ item }">
        <v-btn color="warning" small class="mb-0" @click="confirm(item)">เพิ่มข้อมูล</v-btn>
      </template>-->
      <template v-slot:[`item.actions`]="{ item }">
        <TableMenuCustomer :TableData="item" :whichPage="'new_cus'" v-on:reData="initialize()" ></TableMenuCustomer>
      </template>

      <template
        v-slot:[`item.CONTRACT_START_DATE`]="{ item }"
      >{{ contract_expier(item.CONTRACT_START_DATE,item.CONTRACT_END_DATE) }}</template>
      <template
        v-slot:[`item.CONTRACT_END_DATE`]="{ item }"
      >{{ item.CONTRACT_END_DATE | thdate }}</template>
      <template v-slot:no-data>
        <v-btn color="info" @click="initialize">
          <v-icon left>mdi-refresh</v-icon>รีเฟรชข้อมูล
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import moment from "moment";
import TableMenuCustomer from '../../components/TableMenuCustomer'
import filterCustomer from '../../components/filterCustomer'
export default {
  components:{
    TableMenuCustomer,
    filterCustomer
  },
  data() {
    return {
      isfromNew:true,
      search: "",
      singleSelect: false,
      selected: [],
      headers: [
        {
          text: "ลำดับ",
          align: "start",
          sortable: false,
          value: "index",
        },
        {
          text: "วันที่ติดต่อ",
          align: "start",
          sortable: false,
          value: "nowCreate_DATE",
        },
        {
          text: "รายชื่อ",
          align: "start",
          sortable: false,
          value: "CUSTOMER_NAME",
        },
        { text: "ชื่อผู้ติดต่อ", value: "PROVIDER_NAME" },
        { text: "เบอร์โทร", value: "PROVIDER_PHONE" },
        { text: "จัดการข้อมูล", value: "actions" }
      ],
      desserts: [],
    };
  },
  created() {
    this.listNewcustomer();
    //this.list_c_period();
  },
  computed: {
    // count index in table and chang date format
    getIndex() {
      return this.desserts.map((item, index) => ({
        ...item,
        index: index + 1,
        // create_date: moment(CREATE_DATE)
        //   .add(543, "years")
        //   .format("DD/MM/YYYY hh:mm:ss", true),
      }));
    },
  },
  methods: {
    initialize() {
      this.listNewcustomer();
    },
    confirm(data) {
      this.$store.commit("Quotation/SET_ELEMENT", {
        key: "CUSTOMER_NAME",
        value: data.CUSTOMER_NAME,
      });
      this.$store.commit("Quotation/SET_ELEMENT", {
        key: "CUSTOMER_TAX_ID",
        value: data.CUSTOMER_TAX_ID,
      });
      this.$store.commit("Quotation/SET_ELEMENT", {
        key: "CUSTOMER_BRANCH",
        value: data.CUSTOMER_BRANCH,
      });
      this.$store.commit("Quotation/SET_ELEMENT", {
        key: "CUSTOMER_PROVINCE",
        value: data.CUSTOMER_PROVINCE,
      });
      this.$store.commit("Quotation/SET_ELEMENT", {
        key: "CUSTOMER_DISTRICT",
        value: data.CUSTOMER_DISTRICT,
      });
      this.$store.commit("Quotation/SET_ELEMENT", {
        key: "CUSTOMER_SUBDISTRICT",
        value: data.CUSTOMER_SUBDISTRICT,
      });
      this.$store.commit("Quotation/SET_ELEMENT", {
        key: "CUSTOMER_ZIPCODE",
        value: data.CUSTOMER_ZIPCODE,
      });
      this.$store.commit("Drawer/SET_FROM_CUSTOMER", "customer");
      this.$router.push({ path: "/newCustomer/add-newCustomer" });
    },
    editItem(item) {
      //this.$swal("แก้ไขข้อมูล", "เข้าสู่การแก้ไขข้อมูล", "info");
      //console.log(item)
      //console.log(item.CUSTOMER_ID);
      this.$store.commit("CustomerDetail/SET_DT_CUSTOMER_ID", item.CUSTOMER_ID);
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_NAME",
        item.CUSTOMER_NAME
      );
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_TYPE",
        item.CUSTOMER_TYPE
      );
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_BRANCH",
        item.CUSTOMER_BRANCH
      );
      //--------- commit 3 store - CustomerDT - Quotation - Contract ------------
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_ADRESS",
        item.CUSTOMER_ADDRESS
      );
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_SUBDISTRICT",
        item.CUSTOMER_SUBDISTRICT
      );
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_DISTRICT",
        item.CUSTOMER_DISTRICT
      );
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_PROVINCE",
        item.CUSTOMER_PROVINCE
      );
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_ZIPCODE",
        item.CUSTOMER_ZIPCODE
      );
      // ------------------------------------------------------------
      this.$store.commit("CustomerDetail/SET_DT_CUSTOMER_TEXID", item.CUSTOMER_TAX_ID);
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_OWNER_NAME",
        item.PROVIDER_NAME
      );
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_PHONE",
        item.PROVIDER_PHONE
      );
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_EMAIL",
        item.PROVIDER_EMAIL
      );
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_LINEID",
        item.PROVIDER_LINE_ID
      );
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_FACEBOOK",
        item.PROVIDER_FACEBOOK
      );
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_LINEUSERID",
        item.LINE_USERID
      );
      this.$store.commit("CustomerDetail/SET_MARKERS", {
        lat: item.LATS,
        lng: item.LONGS,
      });
      this.$store.commit("CustomerDetail/SET_IS_EDIT", true);

      //console.log(this.$store.getters["CustomerDetail/GET_DT_MARKERS"])
      //console.log(this.$store.getters["CustomerDetail/IS_EDIT"])
      this.$router.push({ path: "/newCustomer/add-newCustomer" });
    },
    deleteItem(item) {
      const _this = this;
      this.$token_api
        .delete("/delete-Customer", {
          data: { CON_ID: item.CUSTOMER_ID },
        })
        .then((response) => {
          _this.listNewcustomer();
          this.$swal("ลบลูกค้า", "ลูกค้าเรียบร้อย", "question");
        })
        .catch((err) => {});

      //console.log(item)
      console.log(item.CUSTOMER_ID);
    },
    listNewcustomer() {
      this.$token_api
        .get("/list-all-newCustomer")
        .then((response) => {
          let x = response.data.data;
          this.desserts = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    clickReturn(val){
      this.desserts = val
    }
  },
};
</script>